const THEMES = [
  {
    id: "business",
    title: "Business",
    description: "Header includes the Office for National Statistics logo",
  },
  {
    id: "social",
    title: "Social",
    description:
      "Header includes the Office for National Statistics logo but does not include the links for 'Help', 'My account' or 'Sign out'",
  },
  {
    id: "ukhsa-ons",
    title: "Pandemic monitoring",
    description:
      "Header includes the logos for Office for National Statistics and UK Health and Security Agency but does not include the links for ‘Help’, ‘My account’ or ‘Sign out’",
  },
  {
    id: "dbt",
    title: "Department for Business & Trade",
    description: "Header includes the Department for Business & Trade logo",
  },
  {
    id: "dbt-ni",
    title: "Department for Business & Trade - Northern Ireland",
    description:
      "Header includes the logos for Department for Business & Trade and Northern Ireland Department of Finance",
  },
  {
    id: "dbt-dsit",
    title: "Department for Science, Innovation and Technology",
    description:
      "Header includes the logos for Department for Business and Trade and Department for Science, Innovation and Technology",
  },
  {
    id: "dbt-dsit-ni",
    title:
      "Department for Science, Innovation and Technology - Northern Ireland",
    description:
      "Header includes the logos for Department for Business and Trade, Department for Science, Innovation and Technology, and Northern Ireland Department of Finance",
  },
  {
    id: "desnz",
    title: "Department for Energy Security and Net Zero",
    description:
      "Header includes the logo for Department for Energy Security and Net Zero",
  },
  {
    id: "desnz-ni",
    title: "Department for Energy Security and Net Zero - Northern Ireland",
    description:
      "Header includes the logo for Department for Energy Security and Net Zero and Northern Ireland Department of Finance",
  },
  {
    id: "northernireland",
    title: "Northern Ireland Department of Finance",
    description:
      "Header includes the Northern Ireland Department of Finance logo",
  },
  {
    id: "orr",
    title: "Office of Rail and Road",
    description: "Header includes the Office of Rail and Road logo",
  },
  {
    id: "ons-nhs",
    title: "NHS England",
    description:
      "Header includes the logos for NHS England and the Office for National Statistics but does not include the links for 'Help', 'My account' or 'Sign out' ",
  },
];

export default THEMES;
